import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const LoadingState = ({ label = 'Carregando...', minHeight = 240 }) => (
  <Box sx={{ minHeight, display: 'grid', placeItems: 'center', textAlign: 'center' }}>
    <Box>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
        {label}
      </Typography>
    </Box>
  </Box>
);

export default LoadingState;
